// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__1y4NW","main":"Layout_main__gbdP0"};